/* eslint-disable no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import DashboardItem from './DashboardItem';
import './style.scss';

import axios from 'axios';
import { GetProcesso, transformResponse } from 'src/services/auth';
import showToast from '../toastyService';

import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/react';

import Logo from 'src/assets/base/logoNewte.jpg';
import cooCafeLogo from 'src/assets/logos/coocafe.png';
import emfloraLogo from 'src/assets/logos/emflora.png';
import equilibrioLogo from 'src/assets/logos/equilibrio.png';
import nooaLogo from 'src/assets/logos/nooa.png';
import tpjLogo from 'src/assets/logos/tpj.png';
import vixPortLogo from 'src/assets/logos/vixport.png';
import nicchioLogo from 'src/assets/logos/nichio.png';
import tvparanaibaLogo from 'src/assets/logos/tvparanaiba.png';
import xamegobomLogo from 'src/assets/logos/xamegobom.png';
import sorvedocesLogo from 'src/assets/logos/sorvedoces.png';
import ceresLogo from 'src/assets/logos/ceres.png';
import { GetIdentifier } from '../assinatura/auth';
import DefIcon from 'src/assets/base/page.svg';

export default function Dashboard({ ClassName }) {
  const [dados, setDados] = useState([]);
  const [load, setLoad] = useState(true);

  const idEmp = localStorage.getItem('idEmp');
  const loginErp = localStorage.getItem('loginErp');
  const senhaErp = localStorage.getItem('senhaErp');

  const getIdentificador = GetIdentifier();
  const logoList = {
    'coocafe.newlink.app.br': cooCafeLogo,
    'emflora.newlink.app.br': emfloraLogo,
    'equilibrio.newlink.app.br': equilibrioLogo,
    'nooa.newlink.app.br': nooaLogo,
    'tpj.newlink.app.br': tpjLogo,
    'vixport.newlink.app.br': vixPortLogo,
    'nicchio.newlink.app.br': nicchioLogo,
    'tvparanaiba.newlink.app.br': tvparanaibaLogo,
    'xamegobom.newlink.app.br': xamegobomLogo,
    'sorvedoces.newlink.app.br': sorvedocesLogo,
    'ceres.newlink.app.br': ceresLogo,
  };

  const getDashboard = useCallback(() => {
    const data = {
      arqJso:
        '{"Dados": {    "tipoProcesso": "acaoDashboard",    "tipoAcao": "CGRA"  }}',
    };

    GetProcesso('GetMovimento', data, false, false)
      .then((response) => {
        setDados(JSON.parse(response.arqJso).Dados);
        setLoad(false);
      })
      .catch(() => {
        setLoad(false);
      });
  }, [idEmp, loginErp, senhaErp]);

  useEffect(() => {
    getDashboard();
  }, [idEmp, getDashboard]);

  return (
    <div className={`Dashboard ${ClassName}`}>
      {Array.isArray(dados) &&
        dados?.map((item, index) => {
          return (
            <DashboardItem key={index} type={item.type || 'info'} {...item} />
          );
        })}
      {Array.isArray(dados) && dados.length <= 0 && (
        <div className="homeLogo">
          <img
            src={logoList[getIdentificador] ? logoList[getIdentificador] : Logo}
            onError={(e) => {
              e.currentTarget.src = DefIcon;
            }}
          />
        </div>
      )}
    </div>
  );
}

Dashboard.propTypes = {
  ClassName: PropTypes.string,
};
